import { jsx as o, jsxs as h } from "react/jsx-runtime";
import { useState as S, useRef as g, useEffect as y } from "react";
import { Container as L, Editor as T, Toolbar as v, ControlsDivider as i } from "./styles.js";
import { LoadingEditorProvider as D } from "./components/LoadingEditor/index.js";
import { HistoryButtons as H } from "./components/HistoryButtons/index.js";
import { ImageButton as I } from "./components/ImageButton/index.js";
import { LinkButton as O } from "./components/LinkButton/index.js";
import { FormatButton as m } from "./components/FormatButton/index.js";
import { ListButton as B } from "./components/ListButton/index.js";
import { ClearFormatButton as P } from "./components/ClearFormatButton/index.js";
import { useClickOutside as w } from "../../hooks/useClickOutside/index.js";
import { EmojiButton as z } from "./components/EmojiButton/index.js";
function _({
  showToolbarOnFocus: E,
  onClickEditor: j,
  uploadHandler: u,
  onUploadError: x,
  quill: t,
  quillRef: r,
  isLoading: n,
  submitButtonRef: C,
  onSetFocused: s,
  submitted: f,
  hideImageUploadButton: b = !1,
  ...k
}) {
  const [a, d] = S(!1), c = g(null), p = (e) => {
    d(e), s && s(e);
  };
  return y(() => {
    f && d(!1);
  }, [f]), w(
    [c, C],
    () => p(!1)
  ), /* @__PURE__ */ o(
    L,
    {
      ...k,
      ref: c,
      "aria-busy": n,
      onFocus: () => p(!0),
      "data-focused": a,
      children: /* @__PURE__ */ h(D, { initial: n, children: [
        /* @__PURE__ */ o(T, { ref: r, id: "editor", onClick: j }),
        /* @__PURE__ */ h(
          v,
          {
            "aria-hidden": !!E && !a && !n,
            id: "toolbar",
            children: [
              /* @__PURE__ */ o(H, { quill: t }),
              /* @__PURE__ */ o(i, {}),
              /* @__PURE__ */ o(
                I,
                {
                  hidden: b,
                  quill: t,
                  uploadHandler: u,
                  onUploadError: x
                }
              ),
              /* @__PURE__ */ o(z, { onSelect: (e) => {
                if (t && (r != null && r.current)) {
                  const F = t.getLength() - 1;
                  t.insertText(F, e.emoji);
                }
              } }),
              /* @__PURE__ */ o(O, { quill: t }),
              /* @__PURE__ */ o(i, {}),
              /* @__PURE__ */ o(m, { quill: t, format: "bold" }),
              /* @__PURE__ */ o(m, { quill: t, format: "italic" }),
              /* @__PURE__ */ o(m, { quill: t, format: "strike" }),
              /* @__PURE__ */ o(B, { quill: t, list: "bullet" }),
              /* @__PURE__ */ o(B, { quill: t, list: "ordered" }),
              /* @__PURE__ */ o(i, {}),
              /* @__PURE__ */ o(P, { quill: t })
            ]
          }
        )
      ] })
    }
  );
}
export {
  P as ClearFormatButton,
  T as Editor,
  z as EmojiButton,
  m as FormatButton,
  I as ImageButton,
  O as LinkButton,
  B as ListButton,
  _ as RichEditor
};
